<psc-tabs *transloco="let t; read 'user'" [tabsControlFromQueryParams]="true">
  <psc-tab
    [name]="UserProfileTab.Profile"
    [tabTitle]="t('profile.title')">
    <psc-profile></psc-profile>
  </psc-tab>
  <psc-tab
    [name]="UserProfileTab.CompanyProfile"
    *pscRoleAccess="[UserRole.ROLE_BUSINESS, UserRole.ROLE_BUSINESS_EXP, UserRole.ROLE_BUSINESS_PLUS_EXP, UserRole.ROLE_BUSINESS_PLUS]"
    [tabTitle]="t('company-profile.title')">
    <psc-company-profile></psc-company-profile>
  </psc-tab>
  <psc-tab
    [name]="UserProfileTab.PasswordChange"
    [tabTitle]="t('password-change.title')">
    <psc-password-change></psc-password-change>
  </psc-tab>
  <psc-tab
    *pscRoleAccess="[UserRole.ROLE_BUSINESS, UserRole.ROLE_BUSINESS_PLUS, UserRole.ROLE_BUSINESS_EXP, UserRole.ROLE_BUSINESS_PLUS_EXP]"
    [name]="UserProfileTab.Subscription"
    [tabTitle]="t('subscription.tab_title')">
    <psc-subscription></psc-subscription>
  </psc-tab>
  <psc-tab
    *pscRoleAccess="[UserRole.ROLE_PERSONAL]"
    [name]="UserProfileTab.Transactions"
    [tabTitle]="t('transactions.title')">
    <psc-transactions></psc-transactions>
  </psc-tab>
</psc-tabs>
